// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"275":"7ee84a9c8513c01e","2084":"11a6210554b3c1a1","4134":"fe2e7fc66a8da846"}[chunkId] + ".js";
};